import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as peopleApi from '../../api/people';
const initialState = {
    candidates: [],
    incoming: [],
    skippedHistory: [],
    fetchedCityId: null,
    loading: false,
    loadingMore: false,
    exhausted: false,
};
export const fetchCandidates = createAsyncThunk('people/fetchCandidates', async (args) => {
    const data = await peopleApi.getCandidates(args?.limit);
    return { candidates: data, cityId: args?.cityId ?? null };
});
export const fetchMoreCandidates = createAsyncThunk('people/fetchMoreCandidates', async (exclude, { getState }) => {
    return peopleApi.getCandidates(10, exclude);
});
export const fetchIncoming = createAsyncThunk('people/fetchIncoming', async () => {
    return peopleApi.getIncoming();
});
const peopleSlice = createSlice({
    name: 'people',
    initialState,
    reducers: {
        removeTopCandidate(state) {
            state.candidates.shift();
        },
        rotateTopCandidate(state) {
            if (state.candidates.length > 1) {
                const skipped = state.candidates[0];
                state.skippedHistory.push(skipped);
                if (state.skippedHistory.length > 10)
                    state.skippedHistory.shift();
                state.candidates.push(state.candidates.shift());
            }
        },
        undoSkip(state) {
            if (state.skippedHistory.length > 0) {
                const restored = state.skippedHistory.pop();
                state.candidates = state.candidates.filter((c) => c.id !== restored.id);
                state.candidates.unshift(restored);
            }
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCandidates.pending, (state) => {
            state.loading = true;
            state.exhausted = false;
        })
            .addCase(fetchCandidates.fulfilled, (state, action) => {
            state.loading = false;
            state.candidates = action.payload.candidates;
            state.fetchedCityId = action.payload.cityId;
            state.skippedHistory = [];
            if (action.payload.candidates.length === 0) {
                state.exhausted = true;
            }
        })
            .addCase(fetchCandidates.rejected, (state) => {
            state.loading = false;
        })
            .addCase(fetchMoreCandidates.pending, (state) => {
            state.loadingMore = true;
        })
            .addCase(fetchMoreCandidates.fulfilled, (state, action) => {
            state.loadingMore = false;
            if (action.payload.length === 0) {
                state.exhausted = true;
            }
            else {
                // Deduplicate
                const existingIds = new Set(state.candidates.map((c) => c.id));
                const newOnes = action.payload.filter((c) => !existingIds.has(c.id));
                state.candidates.push(...newOnes);
            }
        })
            .addCase(fetchMoreCandidates.rejected, (state) => {
            state.loadingMore = false;
        })
            .addCase(fetchIncoming.fulfilled, (state, action) => {
            state.incoming = action.payload;
        });
    },
});
export const { removeTopCandidate, rotateTopCandidate, undoSkip } = peopleSlice.actions;
export default peopleSlice.reducer;
